import trustPilot from '@ui/ThirdParty/Trustpilot/component'
import collapsibleBlock from 'assets/core/js/module/collapsible-block'
import readMoreText from 'assets/core/js/module/read-more-text'
import common from 'assets/themes/vacances-campings/js/page/common/index'

common.preInit()

document.addEventListener('DOMContentLoaded', function () {
  common.init()

  collapsibleBlock()
  readMoreText()
  trustPilot()
})
